import { Application } from "../../../../Api";
import { ApplicationData, ApplicationDataInterface } from "../../ApplicationData";

export interface CustomApplicationDataInterface extends ApplicationDataInterface {
    salaryRequest: number | null,
    entranceDate: Date | null,
    additionalNotes: string,
    motivation: string,
    periodFrom: Date | null,
    periodTo: Date | null,
    becomingAwareThrough: string,
    pid:string,
    it:string
}

export interface CheckboxFieldInterface {
    displayName: string,
    value: boolean,
    onChange: (e: any) => void,
}

export class CustomApplicationData extends ApplicationData implements CustomApplicationDataInterface {
    salaryRequest: number | null = null;
    entranceDate: Date | null = null;
    additionalNotes: string = "";
    motivation: string = "";
    periodFrom: Date | null = null;
    periodTo: Date | null = null;
    becomingAwareThrough: string = "";
    firstName: string = "";
    lastName: string = "";
    emailAddress: string = "";
    phoneNumber: string = "";
    cvFile: File | undefined = undefined;
    additionalFiles: File[] | null = null;
    terms: boolean = false;
    // H.o.n.e.y.p.o.t
    name: string = "";
    email: string = "";
    pid:string="";
    it:string="";
    getApplication(tenant: string, jobId: string,jobList:string): Application {
        let application = super.getApplication(tenant, jobId,jobList);
        application.customProperties = [];
        application.customProperties.push(
            { name: "salaryRequest", value: this.salaryRequest?.toString() ?? "" },
            { name: "entranceDate", value: this.entranceDate?.toString() ?? "" },
            { name: "additionalNotes", value: this.additionalNotes },
            { name: "motivation", value: this.motivation },
            { name: "periodFrom", value: this.periodFrom?.toString() ?? "" },
            { name: "periodTo", value: this.periodTo?.toString() ?? "" },
            { name: "becomingAwareThrough", value: this.becomingAwareThrough },
        );

        return application;
    }
}
